import { createUseStyles } from 'react-jss';

const styles = {
  actionBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 0 20%',
    '@media(max-width: 1300px)': {
      marginTop: '2rem',
    },
  },
  mobileActionBlock: {
    display: 'flex',
    justifyContent: 'center',
  },
  labelNotChecked: {
    font: { size: '1.4rem', lineHeight: '2rem', weight: 500 },
    textTransform: 'uppercase',
  },
  undoBtn: {
    marginTop: '3.2rem',
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem',
      weight: 700,
    },
    letterSpacing: '0.03rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
